<template>
  <table-wrapper>
    <v-data-table
      class="coronet-table--highlightable"
      :items="items"
      :loading="loading"
      fixed-header
      :no-data-text="$t('general.noDataAvailable')"
      hide-default-footer
    >
      <template #headers>
        <tr>
          <th class="w-45">
            {{ $t("network.secureWebGateway.conditionalForwarding.table.dnsServer") }}
          </th>
          <th class="w-45">
            {{ $t("network.secureWebGateway.conditionalForwarding.table.localDomainName") }}
          </th>
          <th class="w-5" />
        </tr>
      </template>
      <template #item="{ item, index }">
        <tr :key="index" :data-testid="`conditional-forwarding-table-row-${index}`">
          <td :data-testid="`conditional-forwarding-table-dns-server-col-row-${index}`">
            {{ item.dnsServer }}
          </td>
          <td :data-testid="`conditional-forwarding-table-local-domain-col-row-${index}`">
            {{ item.localDomainName }}
          </td>
          <td class="text-right coro-table-col--sticky-right">
            <v-menu offset-y bottom left>
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  :disabled="loading"
                  class="cursor-pointer"
                  icon="$dots"
                  :data-testid="`conditional-forwarding-table-actions-menu-${index}`"
                />
              </template>
              <v-list>
                <v-list-item
                  v-for="action in rowActions"
                  :key="action"
                  :data-testid="`conditional-forwarding-table-action-${action}-${index}`"
                  @click="onActionClick(action, item)"
                >
                  <v-list-item-title>
                    {{ $t(`network.secureWebGateway.conditionalForwarding.actions.${action}`) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </table-wrapper>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import TableWrapper from "@/components/TableWrapper.vue";
import { ConditionalForwardingAction } from "@/constants/network.ts";
import type { ConditionalForwardingItem } from "@/_store/network/swg/conditional-forwarding.module.ts";

export default defineComponent({
  components: { TableWrapper },
  props: {
    items: {
      type: Array as PropType<ConditionalForwardingItem[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["action-applied"],
  setup(_, { emit }) {
    const onActionClick = (
      action: ConditionalForwardingAction,
      item: ConditionalForwardingItem
    ) => {
      emit("action-applied", { action, item });
    };

    return {
      rowActions: [ConditionalForwardingAction.EDIT, ConditionalForwardingAction.REMOVE],
      onActionClick,
    };
  },
});
</script>

<style scoped lang="scss">
.v-table {
  border: 1px solid rgb(var(--v-theme-indigo-faint)) !important;
  box-shadow: none !important;
}
</style>
